import React from 'react';
import { useSelector } from 'react-redux';
import { chatConnectionStatusSelector } from 'domain/chat/legacy/chatSelector';
import { RECONNECTING, FAILED } from 'sendbird-utils/lib/constants';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { styled } from '@mui/material/styles';

const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: theme.borderRadius,
  fontWeight: 500,
  color: theme.palette.common.white,
  backgroundColor: theme.palette.error.main,
  fontSize: theme.typography.pxToRem(14),
  padding: theme.spacing(1, 2),
  marginBottom: theme.spacing(2),
}));

// Only render after a real Sendbird reconnect event (drop or failure). Initial
// state is null (bootstrap, no connect attempt yet) — silent. CONNECTED — silent.
// Avoids flashing "your computer is offline" while sbConnect is in-flight on
// first chat-panel open.
const ALERT_STATUSES = [RECONNECTING, FAILED];

const ChatStatusAlert = () => {
  const status = useSelector(chatConnectionStatusSelector);

  return (
    ALERT_STATUSES.includes(status) && (
      <Wrapper>
        <Box mr={2}>
          <CircularProgress size={20} sx={{ color: 'inherit' }} />
        </Box>
        <FormattedMessage
          id="chat.statusBar.weAreTryingToReconnect"
          defaultMessage="Your computer is offline. Trying to reconnect"
        />
      </Wrapper>
    )
  );
};

export default ChatStatusAlert;
